import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessList = _resolveComponent("BusinessList")!

  return (_openBlock(), _createBlock(_component_BusinessList, {
    tabPanelData: _ctx.tabList,
    pageTypeIn: 'REMOVED',
    canCommand: false,
    marketFeeCanCommand: false,
    businessTypeName: "TABLE_CANCEL_BUSINESS"
  }, null, 8, ["tabPanelData"]))
}